import {Assets} from "@assets/Assets";

export const socialIcon = (type: any = 'Facebook') => {
  try {
    let icon;
    type = type.toLocaleLowerCase();
    switch (type) {
      case "facebook":
        icon = Assets.IconSocialFacebook;
        break;
      case "twitter":
        icon = Assets.IconSocialTwitter;
        break;
      case "linkedin":
        icon = Assets.IconSocialLinkedin;
        break;
      case "youtube":
        icon = Assets.IconSocialYoutube;
        break;
      case "instagram":
        icon = Assets.IconSocialInstagram;
        break;
      case "pinterest":
        icon = Assets.IconSocialPinterest;
        break;
      case "snapchat":
        icon = Assets.IconSocialSnapchat;
        break;
      case "tiktok":
        icon = Assets.IconSocialTiktok;
        break;
    }
    return icon
  } catch (e) {
    console.error(e)
    return ""
  }
}